import React from 'react';
import { webConfig } from '../../configs/system.configs';
class LoadingBilagsky extends React.PureComponent {
  render() {
    const srcLogo = `${webConfig.webUrl}/assets/images/favicon/favicon32.png`;

    return (
      <div className="loading-overlay">
        <img src={srcLogo} alt="Logo" className="loading-logo" loading='lazy' />
        <div className="preloader-wrapper big active">
          <div className="spinner-layer spinner-blue-only">
            <div className="circle-clipper left"><div className="circle"></div></div>
            <div className="gap-patch"><div className="circle"></div></div>
            <div className="circle-clipper right"><div className="circle"></div></div>
          </div>
        </div>
      </div>
    );
  }
}

export default LoadingBilagsky;
